// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"a4254802","883":"e9352c84"}[chunkId] + ".chunk.css";
};